import { useMemo } from 'react';
import { useAuth } from '../../components/authentication/AuthContext';
import { getMembershipAccessModel } from './helpers';

export function useMembershipAccess(options = {}) {
  const auth = useAuth();
  const user = Object.prototype.hasOwnProperty.call(options, 'user')
    ? options.user
    : auth.user;
  const loading = Object.prototype.hasOwnProperty.call(options, 'loading')
    ? options.loading
    : auth.loading;

  return useMemo(
    () => getMembershipAccessModel(user, { loading }),
    [loading, user]
  );
}
